import React from 'react';
import { Chip } from '@mui/material';

type FilterPillProps = {
  label: string;
  onDelete: () => void;
  onClick: () => void;
};

const FilterPill: React.FC<FilterPillProps> = ({ label, onDelete, onClick }) => {
  const maxLength = 20;
  const truncatedLabel =
    label.length > maxLength ? `${label.slice(0, maxLength)}...` : label;

  return (
    <Chip
      label={truncatedLabel}
      onDelete={onDelete}
      onClick={onClick}
      variant="filled"
      style={{ marginRight: 8, backgroundColor: '#ededed' }}
    />
  );
};

export default FilterPill;